@if (flags.loading) {
  <mat-progress-bar mode="indeterminate" [class.iosProgress]="utils.ios()"></mat-progress-bar>
}
@if (users) {
  @if (users.length != 0) {
    <div>
      <div class="resultsHeader" [class.on]="searchStr != null"><mat-icon>face</mat-icon> Members</div>
    </div>
  }
  <div class="squaresContainer" (swipeleft)="swipeLeft()">
    <!-- [href]="'https://activity8.app/'+ user?.username|safe" -->
    @for (user of users; track user; let i = $index) {
      <a class="backgroundSquares "
        [style.background-image]="'url(' + user?.thumbnail?.sm + ')'"
        [@zoomBack]="$safeNavigationMigration(user?.app_state?.homeBackground)" [routerLink]="'/' + $safeNavigationMigration(user?.username)"
        [style.animation-delay]="'0.' +user?.meta?.timing + 's'" [style.background-color]="user?.color + 'c7'" (click)="utils.sound('click-face')" [class.one]="nth(i,3)" [class.three]="nth(i+1,3)">
        <div fxlayout="row">
          <div class="title">
            <!-- {{ post.datetime|date:'E' }} @ {{ post.datetime|date:'shortTime' }} -->
            @if (user?.full_name != '') {
              <span>{{user?.full_name}}</span>
            }
            @if (user?.full_name == '') {
              <span>Mystery</span>
            }
          </div>
          @if (user?.meta?.zodiacMatch) {
            <mat-icon class="premium zodaic">hotel_class</mat-icon>
          }
          @if (user?.is_premium && !user?.is_verified) {
            <mat-icon class="premium" [style.color]="user?.color">star</mat-icon>
          }
          @if (!user?.is_premium && user?.is_verified) {
            <mat-icon class="premium" [style.color]="user?.color">fingerprint</mat-icon>
          }
          @if (user?.is_premium && user?.is_verified) {
            <mat-icon class="premium" [style.color]="user?.color">verified</mat-icon>
          }
          @if (user?.meta?.is_new && !user?.is_verified && !user?.is_premium) {
            <mat-icon class="premium" [style.color]="user?.color">fiber_new</mat-icon>
          }
          @if (!user?.thumbnail?.sm && user?.full_name != '') {
            <div class="noImage">{{$safeNavigationMigration(user?.first_name)|slice:0:3}}</div>
          }
          @if (!user?.thumbnail?.sm && user?.full_name == '') {
            <div class="noImage">:(</div>
          }
        </div>
      </a>
    }
  </div>
  @if (searchStr == null && flags.noResults && !flags.loading) {
    <div class="noResults">
      <h2><mat-icon>face</mat-icon></h2>
      <h5>No more users found</h5>
      <br /><br />
      @if (searchStr) {
        <button mat-button routerLink="/members" onclick="window.scrollTo(0,0)" (click)="searchStr=null;getUsers()"><mat-icon>arrow_back</mat-icon> Back</button>
      }
      <br /><br />
    </div>
  }
}

